import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import {
  EmptyStateUniDriver,
  TextButtonUniDriver,
} from '@wix/design-system/dist/testkit/unidriver';

export default (base: UniDriver, body: UniDriver) => {
  const errorState = () =>
    EmptyStateUniDriver(base.$(`[data-hook="error-state"]`), body);

  const emptyState = () =>
    EmptyStateUniDriver(base.$(`[data-hook="empty-state"]`), body);

  const tryAgainButton = () =>
    TextButtonUniDriver(base.$(`[data-hook="retry-button"]`), body);

  const getCustomFieldLabels = () =>
    base.$$(`[data-hook="custom-field-label"]`).map(async (label) => {
      const text = await label.text();
      return text.substring(0, text.length - 1);
    });

  const getCustomFieldValues = () =>
    base.$$(`[data-hook="custom-field-value"]`).map((value) => value.text());

  return {
    /** Returns title text */
    getTitle: () => base.$(`[data-hook="title"]`).text(),
    /** Indicates whether the widget loading state shows */
    loadingStateExists: () =>
      base.$(`[data-hook="loading-state-skeleton-group"]`).exists(),
    fieldsContentExists: () => base.$(`[data-hook="fields-content"]`).exists(),
    /** Returns the error state title */
    getErrorTitle: () => errorState().getTitleText(),
    /** Returns the error state subtitle */
    getErrorSubtitle: () => errorState().getSubtitleText(),
    /** Returns the empty state title */
    getEmptyTitle: () => emptyState().getTitleText(),
    /** Returns the empty state subtitle */
    getEmptySubtitle: () => base.$(`[data-hook="empty-state-subtitle"]`).text(),
    /** Clicks on try again button when error state visible */
    clickTryAgain: () => tryAgainButton().click(),
    /** Gets try again button text */
    getTryAgainContent: () => tryAgainButton().getButtonTextContent(),
    /** Returns the custom field labels */
    getCustomFieldLabels,
    /** Returns the custom field label by index */
    getCustomFieldLabelByIndex: async (index: number) =>
      (await getCustomFieldLabels())[index],
    /** Returns the custom field values */
    getCustomFieldValues,
    /** Returns the custom field value by index */
    getCustomFieldValueByIndex: async (index: number) =>
      (await getCustomFieldValues())[index],
    ...baseUniDriverFactory(base),
  };
};
